<template><div><h1 id="adressimport-in-eigene-datenbank-fremddatenbank" tabindex="-1"><a class="header-anchor" href="#adressimport-in-eigene-datenbank-fremddatenbank"><span>Adressimport in eigene Datenbank / Fremddatenbank</span></a></h1>
<p>Adressimport in eigene Datenbank / Fremddatenbank — Definiert die Import-Parameter</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Für eine Adressimport werden hier die Parameter wie Quelle, Format, Abgleichsoptionen und anderes gesetzt. Für einzelne Datenfelder wird jeweils ein Importfeld in den Positionen erfasst. Siehe <RouteLink to="/referenz/refs/ft.refdata.adrimppos.html" title="Adressimport in Datenbank (Positionen)">Adressimport in Datenbank (Positionen)</RouteLink> . Die eigentliche Datenübernahme ist in <RouteLink to="/referenz/refs/ft.refproc.adrimp.html" title="Adressimport verarbeiten...">Adressimport verarbeiten...</RouteLink> beschrieben.</p>
<p>Dieses Programm sollte nur von versierten Benutzern verwendet werden. Es wird empfohlen, mit Arenae Kontakt aufzunehmen. Das Prozedere umfasst nicht nur das eigentliche Einlesen der Daten, sondern auch die Überprüfung der Datenqualität und Konformität.</p>
<p>Pfad: <code v-pre>Datenaustausch → Adressimport in eigene Datenbank</code></p>
<h2 id="datenfelder-adressimportfilter-adressimportfilter-in-fremddatenbank" tabindex="-1"><a class="header-anchor" href="#datenfelder-adressimportfilter-adressimportfilter-in-fremddatenbank"><span>Datenfelder (Adressimportfilter / Adressimportfilter in Fremddatenbank)</span></a></h2>
<dl>
<dt>Jahr von</dt>
<dd>Eingrenzung der angezeigten Daten von Jahr</dd>
<dt>bis</dt>
<dd>Eingrenzung der angezeigten Daten bis Jahr</dd>
</dl>
<h2 id="datenfelder-adressimport-in-eigene-datenbank-fremddatenbank" tabindex="-1"><a class="header-anchor" href="#datenfelder-adressimport-in-eigene-datenbank-fremddatenbank"><span>Datenfelder (Adressimport in eigene Datenbank / Fremddatenbank)</span></a></h2>
<dl>
<dt>Job</dt>
<dd>Datum des Einlesejobs</dd>
<dt>ohne Label</dt>
<dd>Laufnummer des Einlesejobs</dd>
<dt>Beschreibung</dt>
<dd>Längere Beschreibung des Einlesejobs</dd>
<dt>importieren in</dt>
<dd>Nummer der Fremddatenbank, die vorher in der Tabelle <a class="link" href="ft.refdata.fremddb.html" title="Fremddatenbank">Fremddatenbank</a> erfasst sein muss.</dd>
</dl>
<div class="hint-container tip">
<p class="hint-container-title">Anmerkung</p>
<p>Dieses Feld ist nur beim Einlesen in die Fremddatenbanken aktiv.</p>
</div>
<dl>
<dt>Quelle</dt>
<dd>Personenquelle, die vorher in der Tabelle <a class="link" href="ft.refdata.tblquelle.html" title="Quellen">Quelle Stammtabelle</a> erfasst sein muss.</dd>
<dt>Quelldatei</dt>
<dd>Upload der Quelldatei</dd>
<dt>Format</dt>
<dd>Format der einzulesenden Datei.
<table>
<thead>
<tr>
<th>Hinweise</th>
</tr>
</thead>
<tbody>
<tr>
<td>getrennt mit ;</td>
</tr>
<tr>
<td>getrennt mit TAB</td>
</tr>
<tr>
<td>feste Feldlänge</td>
</tr>
<tr>
<td>xlsx</td>
</tr>
</tbody>
</table>
</dd>
<dt>Verarbeitungsoptionen</dt>
<dd>
<table>
<thead>
<tr>
<th>Feld</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>postalisch unvollständig</td>
<td>Mindestangaben wie Name oder Ort nicht vorhanden, z.B. eine E-Mail Only Adresse</td>
</tr>
<tr>
<td>Postdatenabweichung</td>
<td>Die postalischen Daten sind fehlerhaft</td>
</tr>
<tr>
<td>unvollständige Vornamen</td>
<td>Vorname nicht ausgeschrieben, z.B. P. statt Peter</td>
</tr>
<tr>
<td>Organisationen</td>
<td>Als Firmen / Organisationen gelten Personen z.B. mit &quot;AG&quot; im Namen, etc.</td>
</tr>
<tr>
<td>Strasse ohne Hausnummer</td>
<td>Die Hausnummer ist nicht vorhanden</td>
</tr>
<tr>
<td>Personen mit Adresszusatz</td>
<td>Zusatzzeile ist nicht leer (kommt oft bei Organisationen vor)</td>
</tr>
</tbody>
</table>
</dd>
<dt>nicht gesperrt / gesperrt</dt>
<dd>Nachfolgend sind die verschiedenen Optionen bei gefundenen-, Haushalts-, ähnlichen- und alten Adressen beschrieben. Diese Optionen sind nochmals in zwei Kategorien &quot;nicht gesperrt&quot; und &quot;gesperrt&quot;&quot; unterteilt, wobei bei gesperrt eine Feineinstellung zwischen generelle Sperre, Kaufsperre und Spendensperre eingestellt werden kann. Die Option generelle Sperre trifft zu, wenn auf Ebene Person gesperrt ist (Refusé-Kategorie Ebene Person), hingegen die Spendensperre oder die Kaufsperre ist eine selektive Sperre.<br>Der Ablauf ist folgendermassen: Zuerst wird immer in der eigenen Datenbank gesucht, und erst dann in der Fremddatenbank (Fremddatenbank nur beim Einlesen von Fremdadressen). Bei erfolgreicher Suche (Treffer) wird die entsprechende Verarbeitungsaktion durchgeführt und die Verarbeitung der Daten geht weiter mit dem nächsten einzulesendem Datensatz. Werden mehrere Personen gefunden und eine davon ist gesperrt, wird die Verarbeitungsaktion, die bei &quot;gesperrt&quot; definiert ist, durchgeführt.
<table>
<thead>
<tr>
<th>Optionen</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>akzeptieren und markieren</td>
<td>gefundene Person wird verwendet, die neue Person wird nicht nocheinmal erfasst</td>
</tr>
<tr>
<td>ignorieren; neue Adresse einlesen</td>
<td>gefundene Person wird ignoriert, die neue Person wird erfasst (Risiko von Dubletten!)</td>
</tr>
<tr>
<td>ignorieren; KEINE Adresse einlesen</td>
<td>gefundene Person wird ignoriert, die neue Person wird NICHT erfasst</td>
</tr>
</tbody>
</table>
</dd>
<dt>gefundene Person</dt>
<dd>Eine gefundene Person ist eine bereits früher erfasste, bzw. eingelesene Person mit identischen Angaben. Dabei werden auch bestimmte Abweichungen in der Schreibweise zugelassen, z.B. ausgeschriebene oder gekürzte Vornamen, Nachnamen mit oder ohne einen Zweitnamen, Strasse mit fehlender Hausnummer (nicht aber unterschiedliche Hausnummer) etc.</dd>
<dt>Haushaltsadressen</dt>
<dd>Als Haushaltsadressen gelten diejenigen Adressen, die bis auf den Vornamen identisch mit einer anderen Adresse sind.</dd>
<dt>ähnliche Adressen</dt>
<dd>Als ähnliche Adressen gelten diejenigen Adressen, die gewisse Übereinstimmungen mit einer anderen Adresse haben. Z.B. Strasse, Hausnummer und Ort stimmen überein, jedoch der Name ist unterschiedlich geschrieben (Meier und Meyer), oder Name, Vorname und Ort stimmen überein, jedoch die Strasse nicht, etc.</dd>
<dt>alte Adressen</dt>
<dd>Als &quot;alte Adressen&quot; gelten Personen, die als früher gültige Personen gefunden werden (im Bereich Mutationen sichtbar), oder die postalische Adresse mit einer bekannten, aber nicht mehr gültigen Adresse übereinstimmt, oder beim Einlesen der Fremdadressen eine Fremdadresse gefunden wird, die mit einer Person in eigener Datenbank verlinkt ist. Diese kann inzwischen eine andere postalische Adresse haben, bzw. wurde eine andere Datenänderung gemacht.</dd>
<dt>geprüft</dt>
<dd>Anzahl geprüfter Adressen (Anzahl in der Quelle)</dd>
<dt>übernommen</dt>
<dd>Anzahl Adressen, die übernommen wurden</dd>
<dt>Einlesedatum</dt>
<dd>Einlesedatum</dd>
<dt>Status</dt>
<dd>
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>erfasst</td>
<td>Job ist erfasst, aber der Adressimport noch nicht gestartet oder nur ein Testlauf durchgeführt</td>
</tr>
<tr>
<td>läuft</td>
<td>Der Adressimport läuft</td>
</tr>
<tr>
<td>abgebrochen</td>
<td>Der Adressimport wurde abgebrochen</td>
</tr>
<tr>
<td>abgeschlossen</td>
<td>Der Adressimport wurde erfolgreich durchgeführt</td>
</tr>
</tbody>
</table>
</dd>
<dt>Protokoll</dt>
<dd>Nach dem Adressimport oder auch beim Testeinlesen wird ein Protokoll vom Adressimport erstellt. Der entsprechende Job mit Protokoll wird hier mittels Status und Job-ID angezeigt.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="adressimport-verarbeiten" tabindex="-1"><a class="header-anchor" href="#adressimport-verarbeiten"><span>Adressimport verarbeiten...</span></a></h3>
<p>Startet oder setzt das Einlesen fort (siehe <RouteLink to="/referenz/refs/ft.refproc.adrimp.html" title="Adressimport verarbeiten...">Adressimport verarbeiten...</RouteLink> ).</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.adrimppos.html" title="Adressimport in Datenbank (Positionen)">Adressimport in Datenbank (Positionen)</RouteLink> , <RouteLink to="/referenz/refs/ft.refproc.adrimp.html" title="Adressimport verarbeiten...">Adressimport verarbeiten...</RouteLink></p>
</div></template>


